import { authorize, putRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function updateUserIn2nAPI(user, data) {
  const url = `${AWS_API_URL}/2n/users/${user?.Id}`;

  let formattedCards = [];
  formattedCards = data?.rfIdTagOne ? [...formattedCards, data.rfIdTagOne] : formattedCards;
  formattedCards = data?.rfIdTagTwo ? [...formattedCards, data.rfIdTagTwo] : formattedCards;

  const hasPropertyRifIdTags = Object.hasOwn(data, 'rfIdTagOne')
   && Object.hasOwn(data, 'rfIdTagTwo');

  const filteredGroupsAndPermissions = data?.groupsAndPermissions?.filter(group => group.value !== '' && group.label !== '');

  const hasPropertyGroupsAndPermissions = Object.hasOwn(data, 'groupsAndPermissions');

  return putRequest(url, {
    data: {
      ...(hasPropertyGroupsAndPermissions && { groupIds: filteredGroupsAndPermissions?.map((group) => group?.value) }),
      isSuspended: data?.isSuspended,
      ...(hasPropertyRifIdTags && { cards: formattedCards }),
      phoneNumbers: data?.phoneNumbers,
    },
  }, await authorize());
}
